module.exports = __webpack_public_path__ + "roc360-logo.18bd7d7.png";